import loadAnalytics from 'analytics.js-loader';

function createAnalytics() {
  let analytics;
  const writeKey = global.CLIENT_ENV && global.CLIENT_ENV.SEGMENT_IO_WRITE_KEY;
  if (typeof document !== 'undefined' && writeKey) {
    analytics = loadAnalytics({ writeKey, skipPageCall: true });
  }

  return {
    trackPage(options) {
      if (!analytics) {
        return;
      }
      options = options || {};
      analytics.page(
        options.category,
        options.name,
        options.properties,
        options.options,
        options.callback
      );
    },

    trackEvent(options) {
      if (!analytics) {
        return;
      }
      options = options || {};
      analytics.track(options.event, options.properties, options.options, options.callback);
    },

    trackError(options) {
      if (!analytics) {
        return;
      }
      options = options || {};
      const properties = Object.assign({}, options.properties);
      if (options.error) {
        properties.error = String(options.error);
      }
      analytics.track('Error', properties, options.options, options.callback);
    },

    ready(callback) {
      if (!analytics) {
        return;
      }
      analytics.ready(callback);
    },
  };
}

export default createAnalytics();
